<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Persona {{ form.nombre }}</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <form v-show="!datos_persona_resumida" method="post" enctype="multipart/form-data" :action="urlImportacion">
              <div class="form-inline">
                  <div class="form-group">
                      <input type="file" name="archivo" id="archivo">
                  </div>
                  <div class="form-group">
                      <button class="btn-success"><i class="fa fa-upload"></i><span>Importar</span></button>
                  </div>
              </div>
              <input type="hidden" name="_token" id="_token" :value="token">
          </form>
          <div v-show="tipoFiltro === ''" class="card">
            <div class="card__content">
              <div class="form-inline">
                <label for="clt">
                  <input type="checkbox" v-model="form.es_cliente" id="clt" />
                  <span>Cliente</span>
                </label>
                <label for="proveedor">
                  <input type="checkbox" v-model="form.es_proveedor" id="proveedor" />
                  <span>Proveedor</span>
                </label>
                <label for="transportistaP">
                  <input type="checkbox" v-model="form.es_transportista" id="transportistaP" />
                  <span>Transportista</span>
                </label>
              </div>
            </div>
          </div>
          <div v-show="searchButton && (permiteEditarPersona || permiteEliminarPersona)">
            <button type="button" class="btn-info btn--bigger" @click="buscarPersona">
              <i class="fa fa-search"></i>
              <span>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <form autocomplete="off" method="POST" @submit.prevent="submit">
      <div class="layout__main">
        <div class="layout__main-form">
          <div class="card">
            <div class="card__content">
              <div class="row">
                <div class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      type="text"
                      id="nombre"
                      placeholder="Ingrese nombre completo"
                      v-model="form.nombre"
                    >
                      <span>Nombre *</span>
                      <span v-if="errores.nombre" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.nombre[0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-4">
                  <div class="form-inline">
                    <label>
                      <p>
                        <strong>Tipo de persona *</strong>
                      </p>
                    </label>
                    <label for="natural">
                      <input
                        @change="cargarTiposIdentificacion"
                        type="radio"
                        id="natural"
                        v-model="form.tipo_persona"
                        value="N"
                      />
                      <span>Natural</span>
                    </label>
                    <label for="juridica">
                      <input
                        @change="cargarTiposIdentificacion"
                        type="radio"
                        id="juridica"
                        v-model="form.tipo_persona"
                        value="J"
                      />
                      <span>Jurídica</span>
                    </label>
                  </div>
                </div>
                <div class="col-xs-12 col-md-4">
                  <div class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        :tooltip="selectedTipoIdentificacion!==null?selectedTipoIdentificacion.descripcion:'Seleccione...'"
                        v-model="selectedTipoIdentificacion"
                        :options="tiposIdentificacion"
                        placeholder="Seleccione..."
                        label="descripcion"
                      ></v-select>
                      <label for="tipoIdentificacion">Tipo de identificación *</label>
                      <span
                        v-if="errores.id_tipo_identificacion"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.id_tipo_identificacion[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      :readonly="tieneNumeroPorDefecto"
                      type="tel"
                      id="cedulaRuc"
                      placeholder="Ingrese Ced/Ruc"
                      v-mask="formatoIdentificacion"
                      v-model="form.identificacion"
                      @input="inputIdentificacion"
                    >
                      <span>Número de identificación *</span>
                      <span
                        v-if="errores.identificacion"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.identificacion[0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida" class="col-xs-12 col-md-4">
                  <div class="form-inline">
                    <label>
                      <p>
                        <strong>Sexo *</strong>
                      </p>
                    </label>
                    <label for="masculino">
                      <input type="radio" id="masculino" v-model="form.sexo" value="M" />
                      <span>Masculino</span>
                    </label>
                    <label for="femenino">
                      <input type="radio" id="femenino" v-model="form.sexo" value="F" />
                      <span>Femenino</span>
                    </label>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida" class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      vMoney
                      :format="int"
                      type="text"
                      id="telefono"
                      placeholder="Ingrese el teléfono"
                      v-model="form.telefono"
                    >
                      <span>Teléfono</span>
                    </input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      type="text"
                      id="email"
                      placeholder="Ingrese el email"
                      v-model="form.email"
                    >
                      <span>E-mail * ("," para separar varios)</span>
                      <span v-if="errores.email" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.email[0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida" class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      type="text"
                      id="contacto"
                      placeholder="Ingrese contacto"
                      v-model="form.contacto"
                    >
                      <span>Contacto</span>
                    </input-field>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida" class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      type="text"
                      id="comentario"
                      placeholder="Ingrese comentario"
                      v-model="form.comentario"
                    >
                      <span>Comentario</span>
                    </input-field>
                  </div>
                </div>
                <div class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      type="text"
                      id="direccion"
                      placeholder="Ingrese dirección"
                      v-model="form.direccion"
                    >
                      <span>Dirección *</span>
                      <span v-if="errores.direccion" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.direccion[0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida"  class="col-xs-12 col-md-4">
                  <div class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        :tooltip="selectedPais!==null?selectedPais.nombre:'Seleccione...'"
                        v-model="selectedPais"
                        :options="paises"
                        placeholder="Seleccione..."
                        label="nombre"
                      ></v-select>
                      <label for="pais">País *</label>
                    </div>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida"  class="col-xs-12 col-md-4">
                  <div class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        :tooltip="selectedProvincia!==null?selectedProvincia.nombre:'Seleccione...'"
                        v-model="selectedProvincia"
                        :options="provincias"
                        placeholder="Seleccione..."
                        label="nombre"
                      ></v-select>
                      <label for="provincia">Provincia *</label>
                    </div>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida"  class="col-xs-12 col-md-4">
                  <div class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        :tooltip="selectedCiudad!==null?selectedCiudad.nombre:'Seleccione...'"
                        v-model="selectedCiudad"
                        :options="ciudades"
                        placeholder="Seleccione..."
                        label="nombre"
                      ></v-select>
                      <label for="ciudad">Ciudad *</label>
                      <span v-if="errores.id_ciudad" class="helper-text text-danger" slot="helper">
                        <strong>{{ errores.id_ciudad[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida"  class="col-xs-12 col-md-4">
                  <div class="form-inline">
                    <label for="obligado_contabilidad">
                      <input
                        type="checkbox"
                        v-model="form.obligado_contabilidad"
                        id="obligado_contabilidad"
                      />
                      <span>Obligado a llevar contabilidad</span>
                    </label>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida" class="col-xs-12 col-md-8">
                  <div class="form-group">
                    <input-field
                      :type="tipoClave"
                      id="clave_portal"
                      v-show="!generarClave"
                      placeholder="Ingrese la clave"
                      v-model="form.clave_portal"
                    >
                      <span>Clave de portal de acceso *</span>
                      <span
                        v-if="errores.clave_portal"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.clave_portal[0] }}</strong>
                      </span>
                    </input-field>
                    <input-field
                      readonly
                      v-show="generarClave"
                      :type="tipoClave"
                      id="clave_generada"
                      placeholder="Ingrese la clave"
                      v-model="form.clave_portal"
                    >
                      <span>Clave de portal de acceso *</span>
                      <span
                        v-if="errores.clave_portal"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.clave_portal[0] }}</strong>
                      </span>
                    </input-field>
                    <label for="generarClave">
                      <input
                        @change="generarClavePortal"
                        type="checkbox"
                        id="generarClave"
                        v-model="generarClave"
                      />
                      <span>Generar clave</span>
                    </label>
                    <button
                      @click="generarClavePortal"
                      class="btn-secondary"
                      type="button"
                      v-show="generarClave"
                    >
                      <i class="fa fa-refresh"></i>
                    </button>
                    <button @click="verClave" class="btn-info" type="button">
                      <i
                        class="fa"
                        :class="{'fa-eye' : claveOculta, 'fa-eye-slash' : !claveOculta}"
                      ></i>
                    </button>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida"  class="col-xs-12 col-md-4">
                  <div class="form-inline">
                    <label>
                      <input
                        type="checkbox"
                        v-model="form.contribuyente_especial"
                        id="contribuyente_especial"
                      />
                      <span>Contribuyente Especial</span>
                    </label>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida"  class="col-xs-12 col-md-4">
                  <div class="form-field">
                    <input-field
                      type="text"
                      id="titulo"
                      placeholder="Ingrese el número"
                      v-show="form.contribuyente_especial"
                      v-model="form.numero_cont_espec"
                    >
                      <span>Número de contribuyente especial</span>
                      <span
                        v-if="errores.numero_cont_espec"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.numero_cont_espec[0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </div>
                <div v-show="!datos_persona_resumida"  class="col-xs-12 col-md-6 col-lg-4">
                  <div class="form-field">
                    <input-field type="tel" v-mask="'#'" id="decimales_compras" v-model="form.decimales_compras" placeholder="#">
                      Decimales en compras
                    </input-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="layout__main-buttons">
          <div class="card">
            <div class="card__content">
              <button
                v-show="(permiteCrearPersona && estado === 'N') || (permiteEditarPersona && estado !== 'N')"
                class="btn-success"
                @click="submit"
                type="button"
              >
                <i class="fa fa-save"></i>
                <span>Guardar</span>
              </button>
              <button
                v-show="permiteCrearPersona && closable"
                @click="crearPersona"
                type="button"
                class="btn-light btn--text"
              >
                <i class="fa fa-plus"></i>
                <span>Nueva</span>
              </button>
              <button
                v-show="permiteEliminarPersona"
                :disabled="estado === 'N'"
                class="btn--text"
                :class="{'btn-danger' : estado === 'A' || estado === 'N', 'btn-success' : estado === 'I'}"
                type="button"
                @click="anularPersona"
              >
                <i class="fa fa-ban"></i>
                <span>{{ (estado === 'I')?'Re-activar':'Bloquear' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <modal :width="'60%'" height="auto" :scrollable="true" name="listaPersonas">
      <lista-personas
        @selected="cargarPersonaSeleccionada"
        @cerrarModal="cerrarModal"
        :createButton="createButton"
        ref="listaPersonas"
      ></lista-personas>
    </modal>
  </div>
</template>
<script>
export default {
  computed: {
    tipoClave: function() {
      return this.claveOculta ? "password" : "text";
    },
    formatoIdentificacion: function() {
      if (this.selectedTipoIdentificacion !== null) {
        if (this.selectedTipoIdentificacion.id_tipo_identificacion === "09")
          return "AAA####";
        else if (
          this.selectedTipoIdentificacion.id_tipo_identificacion === "04"
        )
          return "#############";
        else if (
          this.selectedTipoIdentificacion.id_tipo_identificacion === "05"
        )
          return "##########";
      }
      return "XXXXXXXXXXXXXXXXXXXX";
    }
  },
  props: {
    token: {
      type: String,
      required: false,
      default: ''
    },
    urlImportacion: {
        type : String,
        required : false,
        default: url + '/personas/importar'
    },
    closable: {
      type: Boolean,
      required: false,
      default: true
    },
    correoPersona: {
      type: String,
      required: false,
      default: ""
    },
    nombrePersona: {
      type: String,
      required: false,
      default: ""
    },
    searchButton: {
      type: Boolean,
      default: true
    },
    createButton: {
      type: Boolean,
      default: false,
      required: false
    },
    permiteCrearPersona: {
      type: Boolean,
      default: true,
      required: false
    },
    permiteEditarPersona: {
      type: Boolean,
      default: true,
      required: false
    },
    permiteEliminarPersona: {
      type: Boolean,
      default: true,
      required: false
    },
    numeroIdentificacion: {
      type: String,
      required: false,
      default: ""
    },
    tipoFiltro: {
      type: String,
      required: false,
      default: ""
    }
  },
  data: function() {
    return {
      datos_persona_resumida: false,
      ciudadDefecto: null,
      int: numero,
      decimal: decimal,
      money: money,
      porcentaje: porcentaje,
      form: {
        id: "",
        identificacion: this.numeroIdentificacion,
        nombre: this.nombrePersona,
        telefono: "",
        email: this.correoPersona,
        contacto: "",
        comentario: "",
        direccion: "",
        id_ciudad: "",
        id_tipo_identificacion: "",
        contribuyente_especial: false,
        numero_cont_espec: "",
        obligado_contabilidad: true,
        sexo: "M",
        tipo_persona: "N",
        es_cliente: this.tipoFiltro === "" ? true : this.tipoFiltro === "C",
        es_proveedor: this.tipoFiltro === "" ? true : this.tipoFiltro === "P",
        es_transportista:
          this.tipoFiltro === "" ? false : this.tipoFiltro === "T",
        _method: undefined,
        clave_portal: "",
        generar_clave: false,
        decimales_compras: 2
      },
      errores: {
        id: undefined,
        identificacion: undefined,
        nombre: undefined,
        telefono: undefined,
        email: undefined,
        contacto: undefined,
        comentario: undefined,
        direccion: undefined,
        id_ciudad: undefined,
        id_tipo_identificacion: undefined,
        numero_cont_espec: undefined,
        sexo: undefined,
        tipo_persona: undefined,
        clave_portal: undefined
      },
      estado: "N",
      selectedPais: null,
      selectedCiudad: null,
      selectedProvincia: null,
      selectedTipoIdentificacion: null,
      url: url,
      paises: [],
      ciudades: [],
      provincias: [],
      tiposIdentificacion: [],
      tieneNumeroPorDefecto: false,
      generarClave: false,
      claveOculta: true,
      provinciaActual: "",
      ciudadActual: ""
    };
  },
  watch: {
    selectedPais: function(value) {
      if (value != null && value !== undefined) this.cargarProvinciasPorPais();
      else this.selectedProvincia = null;
    },
    selectedProvincia: function(value) {
      if (value !== null && value !== undefined)
        this.cargarCiudadesPorProvincia();
      else this.selectedCiudad = null;
    },
    selectedCiudad: function(value) {
      if (value !== null && value !== undefined)
        this.form.id_ciudad = value.id_ciudad;
      else this.form.id_ciudad = "";
    },
    selectedTipoIdentificacion: function(value) {
      if (value !== undefined && value !== null) {
        this.form.id_tipo_identificacion = value.id_tipo_identificacion;
        if (value.numero_defecto !== null && value.numero_defecto !== "") {
          this.tieneNumeroPorDefecto = true;
          this.form.identificacion = value.numero_defecto;
        } else this.tieneNumeroPorDefecto = false;
      } else {
        this.form.id_tipo_identificacion = "";
        this.tieneNumeroPorDefecto = false;
      }
    }
  },
  mounted: function() {
    this.form.clave_portal = this.numeroIdentificacion;
    this.cargarDatos();
    this.cargarTiposIdentificacion();
  },
  methods: {
    inputIdentificacion: function () {
      this.form.clave_portal = this.form.identificacion;
    },
    generarClavePortal: function() {
      if (this.generarClave)
        this.form.clave_portal = new RandExp(/^[0-9]{8}$/).gen();
      this.form.generar_clave = this.generarClave;
    },
    ponerCiudadDefecto: function () {
      let that = this;
      if (that.selectedCiudad == null && that.ciudadDefecto != null) {
          that.selectedPais = that.ciudadDefecto.provincia.pais;
          that.selectedProvincia = that.ciudadDefecto.provincia;
          that.selectedCiudad = that.ciudadDefecto;
          that.form.id_ciudad = that.ciudadDefecto.id_ciudad;
        } 
    },
    cargarDatos: function() {
      let that = this;
      axios.get(this.url + "/personas/datos").then(function(response) {
        let data = response.data;
        that.paises = data.paises;
        that.ciudadDefecto = data.ciudadDefecto;
        that.datos_persona_resumida = data.datos_persona_resumida;
        that.ponerCiudadDefecto();
      });
    },
    submit: function() {
      let that = this;
      this.errores = {
        id: undefined,
        identificacion: undefined,
        nombre: undefined,
        telefono: undefined,
        email: undefined,
        contacto: undefined,
        comentario: undefined,
        direccion: undefined,
        id_ciudad: undefined,
        id_tipo_identificacion: undefined,
        numero_cont_espec: undefined,
        sexo: undefined,
        tipo_persona: undefined,
        clave_portal: undefined
      };
      let urlRequest =
        this.estado === "N"
          ? this.url + "/personas"
          : this.url + "/personas/" + this.form.id;
      if (this.estado !== "N") this.form._method = "PUT";
      axios
        .post(urlRequest, this.form)
        .then(function(response) {
          swal(
            "Los datos fueron almacenados corréctamente.",
            "Realizado",
            "success"
          );
          that.estado = response.data.estado;
          that.form.id = response.data.id;
          that.$emit("saved", response.data);
        })
        .catch(function(error) {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              if (response.status === 422) {
                that.errores = response.data.errors;
                swal("Verifique los datos ingresados.", "Error", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          }
        });
    },
    limpiarErrores: function() {
      this.errores = {
        id: undefined,
        identificacion: undefined,
        nombre: undefined,
        telefono: undefined,
        email: undefined,
        contacto: undefined,
        comentario: undefined,
        direccion: undefined,
        id_ciudad: undefined,
        id_tipo_identificacion: undefined,
        numero_cont_espec: undefined,
        sexo: undefined
      };
    },
    cargarTiposIdentificacion: function() {
      let url = this.url + "/tipos-identificacion/";
      if (this.form.tipo_persona === "N") url += "naturales";
      else url += "juridicas";
      let that = this;
      axios.get(url).then(function(response) {
        that.tiposIdentificacion = response.data;
        if (that.numeroIdentificacion !== "") {
          let regex = new RegExp("^[a-zA-Z]{3}[0-9]{3,4}$");
          if (regex.test(that.numeroIdentificacion))
            that.form.id_tipo_identificacion = "09";
          else {
            regex = new RegExp("^[0-9]{10}$");
            if (regex.test(that.numeroIdentificacion))
              that.form.id_tipo_identificacion = "05";
            else {
              regex = new RegExp("^[0-9]{13}$");
              if (regex.test(that.numeroIdentificacion))
                that.form.id_tipo_identificacion = "04";
            }
          }
        }
        for (let i = 0; i < that.tiposIdentificacion.length; i++)
          if (
            that.tiposIdentificacion[i].id_tipo_identificacion ===
            that.form.id_tipo_identificacion
          ) {
            that.selectedTipoIdentificacion = that.tiposIdentificacion[i];
            break;
          }
      });
    },
    cargarCiudadesPorProvincia: function() {
      let that = this;
      axios
        .get(this.url + "/ciudades/" + this.selectedProvincia.id_provincia)
        .then(function(response) {
          that.ciudades = response.data;
          for (let i = 0; i < that.ciudades.length; i++)
            if (that.ciudades[i].id_ciudad == that.ciudadActual) {
              that.selectedCiudad = that.ciudades[i];
              that.ciudadActual = "";
              break;
            }
        });
    },
    cargarProvinciasPorPais: function() {
      let that = this;
      axios
        .get(this.url + "/provincias/" + this.selectedPais.id_pais)
        .then(function(response) {
          that.provincias = response.data;
          for (let i = 0; i < that.provincias.length; i++)
            if (that.provincias[i].id_provincia == that.provinciaActual) {
              that.selectedProvincia = that.provincias[i];
              that.provinciaActual = "";
              break;
            }
        });
    },
    cargarPersonaSeleccionada: function(currentPersona) {
      this.selectedPais = null;
      this.form.id = currentPersona.id;
      this.form.identificacion = currentPersona.identificacion;
      this.form.contribuyente_especial =
        currentPersona.contribuyente_especial === "S";
      this.form.numero_cont_espec = currentPersona.numero_cont_espec;
      this.form.obligado_contabilidad =
        currentPersona.obligado_contabilidad === "S";
      this.form.sexo = currentPersona.sexo;
      this.form.tipo_persona = currentPersona.tipo_persona;
      this.form.id_tipo_identificacion = currentPersona.id_tipo_identificacion;
      this.form.es_cliente = currentPersona.es_cliente === "S";
      this.form.es_proveedor = currentPersona.es_proveedor === "S";
      this.form.es_transportista = currentPersona.es_transportista === "S";
      this.form.nombre = currentPersona.nombre;
      this.form.telefono = currentPersona.telefono;
      this.form.email = currentPersona.email;
      this.form.contacto = currentPersona.contacto;
      this.form.comentario = currentPersona.comentario;
      this.form.direccion = currentPersona.direccion;
      this.form.clave_portal = "";
      this.form.decimales_compras = currentPersona.decimales_compras;
      this.estado = currentPersona.estado;
      if (currentPersona.ciudad !== null)
        for (let i = 0; i < this.paises.length; i++)
          if (
            currentPersona.ciudad.provincia !== null &&
            this.paises[i].id_pais === currentPersona.ciudad.provincia.id_pais
          ) {
            this.selectedPais = this.paises[i];
            this.provinciaActual = currentPersona.ciudad.id_provincia;
            this.ciudadActual = currentPersona.id_ciudad;
            break;
          }
      this.cargarTiposIdentificacion();
    },
    buscarPersona: function() {
      this.$modal.show("listaPersonas");
    },
    cerrarModal: function() {
      this.$modal.hide("listaPersonas");
    },
    reiniciarFormulario: function() {
      this.selectedPais = null;
      this.selectedCiudad = null;
      this.selectedTipoIdentificacion = null;
      this.form = {
        id: "",
        identificacion: "",
        nombre: "",
        telefono: "",
        email: "",
        contacto: "",
        comentario: "",
        direccion: "",
        id_ciudad: "",
        id_tipo_identificacion: "",
        contribuyente_especial: false,
        numero_cont_espec: "",
        obligado_contabilidad: true,
        sexo: "M",
        tipo_persona: "N",
        es_cliente: true,
        es_proveedor: false,
        es_transportista: false,
        _method: undefined,
        decimales_compras: 2
      };
      this.estado = "N";
      this.limpiarErrores();
      this.claveOculta = true;
      this.generarClave = false;
      this.ponerCiudadDefecto();
    },
    verClave: function() {
      if (this.claveOculta) this.claveOculta = false;
      else this.claveOculta = true;
    },
    crearPersona: function() {
      let that = this;
      swal({
        title: "¿Desear crear una nueva persona?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Nueva persona",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          that.reiniciarFormulario();
          that.cargarTiposIdentificacion();
        }
      });
    },
    anularPersona: function() {
      let that = this;
      swal({
        title:
          "¿Deseas " +
          (that.estado === "A" ? "eliminar" : "re-activar") +
          " esta persona?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: that.estado === "A" ? "Bloquear" : "Re-activar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          axios
            .post(that.url + "/personas/" + that.form.id, {
              _method: "DELETE"
            })
            .then(function(response) {
              swal(
                "Hecho",
                "El estado de la persona ha sido cambiado.",
                "success"
              );
              that.estado = response.data.estado;
            });
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/personas/Persona.vue